import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import type { AvailabilityReportItem } from '../../types/reports';
import AccessibleChartSummary from './AccessibleChartSummary';

const COLORS = ['#2563EB', '#7C3AED', '#EA580C', '#16A34A', '#64748B'];

export default function AvailabilityChart({ data }: { data: AvailabilityReportItem[] }) {
  // "Unknown" availability types are already excluded upstream in ReportsPage
  const chartData = data.map((item) => ({
    name: item.availabilityTypeName || item.availabilityType || 'Availability',
    count: item.userCount ?? item.count ?? 0,
  }));
  const totalExperts = chartData.reduce((total, item) => total + item.count, 0);

  return (
    <>
      <div className="relative">
        <ResponsiveContainer width="100%" height={270}>
          <PieChart>
            <Pie data={chartData} dataKey="count" nameKey="name" innerRadius={70} outerRadius={110} paddingAngle={3}>
              {chartData.map((item, index) => (
                <Cell key={item.name} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => [`${value} experts`, 'Count']} />
          </PieChart>
        </ResponsiveContainer>
        <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-3xl font-bold text-slate-900">{totalExperts}</span>
          <span className="text-xs font-medium uppercase tracking-wide text-slate-500">Experts</span>
        </div>
      </div>
      <AccessibleChartSummary caption="Availability distribution" categoryHeader="Availability type" valueHeader="People" rows={chartData.map((item) => ({ label: item.name, value: item.count }))} />
    </>
  );
}
